// import React, { useEffect, useState } from 'react'
// import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
// import { useSelector } from 'react-redux';
// import { Button, Container, Modal, Row } from 'react-bootstrap';
// import axios from 'axios';
// import CustomInput from '../components/CustomInput/CustomInput';

// function Notifications() {
//     const { currentLocal } = useSelector((state) => state.currentLocal);
//     const [show, setShow] = useState(false)
//     const [resson, setReson] = useState('')
//     const userinfo = useSelector((state) => state);
//     const [items, setItems] = useState([])
//     const [itemsEx, setItemsEx] = useState([])
//     const [selectedItem, setSelectedItem] = useState(null); // store current item


//     const handleClose = () => setShow(false)
//     const getData = async () => {

//         try {
//             const response = await axios.get('https://nanosoft.space/taarteb/public/api/admin/student-fees', {
//                 headers: {
//                     Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                 },
//             });
//             setItems(response.data.data);


//         } catch (error) {
//             console.log(error);

//         }
//         try {
//             const response = await axios.get('https://nanosoft.space/taarteb/public/api/admin/student-expenses', {
//                 headers: {
//                     Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                 },
//             });
//             setItemsEx(response.data.data);
// console.log(response.data.data);


//         } catch (error) {
//             console.log(error);

//         }
//     }
//     useEffect(() => {

//         getData()
//     }, [])
//     return (
//         <div>
//             <AuthNavbar

//             />
//             <Container>
//                 <Row>
//                     <h5>{currentLocal.home.Notifications}</h5>
//                     <div className='mt-4 border p-3 rounded'>
//                         {
//                             items.map((item) => {
//                                 console.log(item?.payment_method);

//                                 return (
//                                     <div className='d-flex align-items-center border-bottom py-3 justify-content-between'>
//                                         <Modal
//                                             aria-labelledby="contained-modal-title-vcenter"
//                                             centered

//                                             show={show} onHide={handleClose}>

//                                             <Modal.Body className='border-0'>
//                                                 <CustomInput
//                                                     placeholder={currentLocal.home.resonOfreject}
//                                                     value={resson}
//                                                     onChange={(e) => setReson(e.target.value)}

//                                                 />
//                                             </Modal.Body>
//                                             <Modal.Footer className='border-0'>
//                                                 <Button variant="secondary" onClick={handleClose}>
//                                                     {currentLocal.home.close}
//                                                 </Button>
//                                                 <Button variant="primary" onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`, {
//                                                             "payment_status": "paid",
//                                                             "status": "rejected",
//                                                             "reason": resson
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         setShow(false)
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}>
//                                                     {currentLocal.home.send}
//                                                 </Button>
//                                             </Modal.Footer>
//                                         </Modal>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             {item?.student?.name}
//                                         </div>
//                                         <div>
//                                             {item?.payment_method == 1 ? "cash" : "visa"}
//                                         </div>

//                                         <img src={item?.receipt} style={{ width: "15%", }} />
//                                         <div>
//                                             <button className='btn btn-success mx-2'
//                                                 onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`, {
//                                                             "payment_status": "paid",
//                                                             "status": "accepted"
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}

//                                             >{currentLocal.home.accept}</button>
//                                             <button className='btn btn-danger'
//                                                 onClick={async () => {
//                                                     setShow(true)
//     setSelectedItem(item); // set which item is being rejected

//                                                 }}
//                                             >{currentLocal.home.reject}</button>
//                                         </div>
//                                     </div>
//                                 )
//                             })
//                         }
//                         {
//                             itemsEx.map((item) => {
//                                 console.log(item?.payment_method);

//                                 return (
//                                     <div className='d-flex align-items-center border-bottom py-3 justify-content-between'>
//                                         <Modal
//                                             aria-labelledby="contained-modal-title-vcenter"
//                                             centered

//                                             show={show} onHide={handleClose}>

//                                             <Modal.Body className='border-0'>
//                                                 <CustomInput
//                                                     placeholder={currentLocal.home.resonOfreject}
//                                                     value={resson}
//                                                     onChange={(e) => setReson(e.target.value)}

//                                                 />
//                                             </Modal.Body>
//                                             <Modal.Footer className='border-0'>
//                                                 <Button variant="secondary" onClick={handleClose}>
//                                                     {currentLocal.home.close}
//                                                 </Button>
//                                                 <Button variant="primary" onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`, {
//                                                             "status": "rejected",
//                                                             "rejected_reason": resson
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         setShow(false)
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}>
//                                                     {currentLocal.home.send}
//                                                 </Button>
//                                             </Modal.Footer>
//                                         </Modal>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             {item?.student?.name}
//                                         </div>
//                                         <div>
//                                             {item?.payment_method == 1 ? "cash" : "visa"}
//                                         </div>

//                                         <img src={item?.receipt} style={{ width: "15%", }} />
//                                         <div>
//                                             <button className='btn btn-success mx-2'
//                                                 onClick={async () => {
//                                                     console.log(selectedItem?.id);

//                                                     // try {
//                                                     //     const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`, {
//                                                     //         "status": "accepted"
//                                                     //     }, {
//                                                     //         headers: {
//                                                     //             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                     //         },
//                                                     //     });
//                                                     //     getData()

//                                                     // } catch (error) {
//                                                     //     console.log(error);

//                                                     // }
//                                                 }}

//                                             >{currentLocal.home.accept}</button>
//                                             <button className='btn btn-danger'
//                                                 onClick={async () => {
//                                                     setShow(true)
//     setSelectedItem(item); // set which item is being rejected

//                                                 }}
//                                             >{currentLocal.home.reject}</button>
//                                         </div>
//                                     </div>
//                                 )
//                             })
//                         }
//                     </div>

//                 </Row>

//             </Container>
//         </div>
//     )
// }

// export default Notifications


import React, { useEffect, useState } from "react";
import AuthNavbar from "../components/AuthNavbar/AuthNavbar";
import { useSelector } from "react-redux";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import axios from "axios";
import CustomInput from "../components/CustomInput/CustomInput";
import CustomModel from "../components/CustomModel/CustomModel";
import { useNavigate } from "react-router-dom";

function Notifications() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [amount_paid, setAmount_paid] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [showImg, setShowImg] = useState(false);
  const [imageSrc, setImgSrc] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [acceptState, setAcceptState] = useState(false);
  const [data, setData] = useState({});
  const [statusPending, setstatusPending] = useState(false);
  const [paymentState, setPaymentState] = useState('');

  const [items, setItems] = useState([]);
  const [itemsEx, setItemsEx] = useState([]);

  const handleClose = () => {
    setShow(false);
    setReason("");
    setSelectedItem(null);
    setSelectedType(null);
  };

  // ✅ Read Notification Function
  const ReadNotification = async (ids) => {
    if (!ids || ids.length === 0) return;
    try {
      await axios.post(
        "https://nanosoft.space/taarteb/public/api/notification/read",
        {
          notifications_ids: ids,
        },
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
    } catch (error) {
      console.log("Error marking notifications as read:", error);
    }
  };

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/admin/student-fees",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
      setItems(response.data.data);
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/notification/all",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );

      const fetchedData = response.data.data;
      setData(fetchedData);

      // ✅ Extract unread notification IDs from all grouped arrays
      const allNotifications = Object.values(fetchedData).flat();
      const unreadNotifications = allNotifications.filter((item) => item?.read_at == null);
      const unreadIds = unreadNotifications.map((item) => item.id);

      // ✅ Send IDs to API if there are unread notifications
      if (unreadIds.length > 0) {
        ReadNotification(unreadIds);
      }

    } catch (error) {
      console.log(error);
    }

    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/admin/student-expenses",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
      setItemsEx(response.data.data);
      setPaymentState('expenses');
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [], );

  // ✅ Handle reject submit
  const handleReject = async () => {
    if (!selectedItem || !selectedType) return;
    try {
      if (selectedType === "fees") {
        const body = acceptState === "accept" ? {
          status: acceptState !== "accept" ? "rejected" : "accepted",
        } : {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          reason: acceptState !== "accept" ? reason : "",
        }
        await axios.post(
          `https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          }
        );
      } else {
        const body = acceptState === "accept" ? {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          amount_paid: acceptState === "accept" ? amount_paid : 0
        } : {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          rejected_reason: acceptState !== "accept" ? reason : "",
        }
        const url = `https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`
        await axios.post(
          url,
          body,
          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          }
        );
      }
      handleClose();
      getData();
    } catch (error) {
      console.log(error);
      handleClose();
    }
  };

  const handleShowImg = (img) => {
    setShowImg(true);
    setImgSrc(img);
  };

  return (
    <div>
      <Modal show={showImg} onHide={() => setShowImg(false)} size="lg" centered>
        <Modal.Body className="text-center">
          <img src={imageSrc} alt="full" style={{ width: "100%", height: "auto" }} />
        </Modal.Body>
        <Modal.Footer>
          <a href={imageSrc} download target="_blank" rel="noreferrer">
            <Button variant="primary">{currentLocal?.home?.download || "Download"}</Button>
          </a>
          <Button variant="secondary" onClick={() => setImgSrc(false)}>
            {currentLocal?.home?.close || "Close"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body className="border-0">
          {acceptState === "accept" ?
            paymentState === "expenses" &&
            <CustomInput
              placeholder={currentLocal?.home?.amount_paid || "Amount Paid"}
              value={amount_paid}
              onChange={(e) => setAmount_paid(e.target.value)}
            />
            :
            <CustomInput
              placeholder={currentLocal?.home?.resonOfreject || "Reason of reject"}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          }
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" onClick={handleReject}>
            {currentLocal?.home?.send || "Send"}
          </Button>
          <Button variant="danger" onClick={handleClose}>
            {currentLocal?.home?.close || "Close"}
          </Button>
        </Modal.Footer>
      </Modal>

      <AuthNavbar />
      <Container>
        <Row className="mx-3">
          <h5>{currentLocal?.home?.Notifications || "Notifications"}</h5>
          <div>
            {Object.entries(data || {}).map(([title, items]) => (
              <div key={title} style={{ marginBottom: "20px" }}>
                {title === "maintenance" && <p className="fw-bold">{currentLocal?.home?.Maintenance}</p>}
                {title === "purchase" && <p className="fw-bold">{currentLocal?.home?.Purchases}</p>}
                {title === "expense" && <p className="fw-bold">{currentLocal?.home?.mainexpenses}</p>}
                {title === "student_expense" && <p className="fw-bold">{currentLocal?.home?.Academicyearexpenses}</p>}
                {title === "student_fee" && <p className="fw-bold">{currentLocal?.home?.registrationform}</p>}
                {title === "registration_fee" && <p className="fw-bold">{currentLocal?.home?.Registrationandtuitionfees}</p>}
                
                {items && items.length > 0 ? (
                  <div className="border p-3 rounded">
                    {items.map((item) => (
                      <Row className="mb-3 border-bottom"
                        key={item?.id}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (title === "expense") {
                            navigate("/dashboard/student/Finance");
                          } else if (title === "registration_fee") {
                            navigate("/dashboard/finance");
                          } else if (title === "maintenance") {
                            navigate("/dashboard/maintenance");
                          } else if (title === "purchase") {
                            navigate("/dashboard/Purchases");
                          } else if (title === "student_expense") {
                            navigate("/dashboard/finance");
                          }
                        }}
                      >
                        <Col md={6}>
                          <div className="d-flex align-items-center">
                            <div className="w-25 mx-2" style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowImg(item?.image);
                              }}
                            >
                              <img src={item.image} alt="" className='w-100 rounded' />
                            </div>
                            <div>
                              <p className="mb-1 fw-bold fs-6">{item?.title}</p>
                              <p className="mb-1 fs-6">{item?.description}</p>
                              <p className="mb-1 text-muted">{item?.updated_at}</p>
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="d-flex justify-content-end align-items-center h-100">
                            {/* Actions / Buttons based on title */}
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                ) : (
                  <p>No data found</p>
                )}
              </div>
            ))}
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default Notifications;